const medicalInterests = [
  {
    "id": 1,
    "name": "Mental health",
    "icon": "fas fa-brain",
    "description": "Mental health, which relates to your emotional well-being, includes how you feel inside, like dealing with things such as depression, stress and anxiety."
  },
  {
    "id": 2,
    "name": "Women’s health",
    "icon": "fas fa-venus",
    "description": "Women’s health focuses on both common and unique aspects, including reproductive health, breast health, hormonal changes and mental health."
  },
  {
    "id": 3,
    "name": "Men’s health",
    "icon": "fas fa-mars",
    "description": "Men's health involves taking care of the physical and mental well-being of men, addressing issues like regular check-ups, prostate screening, blood pressure, and overall health."
  },
  {
    "id": 4,
    "name": "Seniors’ health",
    "icon": "fas fa-user-friends",
    "description": "Older people's health is about looking after the well-being of seniors, addressing their specific health needs, and helping them stay active and independent as they age."
  },
  {
    "id": 5,
    "name": "Children’s health",
    "icon": "fas fa-child",
    "description": "Children's health covers everything related to keeping kids physically and mentally well, from birth to adolescence, including regular check-ups, vaccinations, and addressing common childhood issues."
  },
  {
    "id": 6,
    "name": "Youth health",
    "icon": "fas fa-user-graduate",
    "description": "Youth health is all about keeping young people physically and mentally well, addressing their unique needs and challenges as they grow up."
  },
  {
    "id": 7,
    "name": "Sexual health",
    "icon": "fas fa-heart",
    "description": "Children's health covers everything related to keeping kids physically and mentally well, from birth to adolescence, including regular check-ups, vaccinations, and addressing common childhood issues."
  },
  {
    "id": 8,
    "name": "Heart health",
    "icon": "fas fa-heartbeat",
    "description": "Cardiovascular health refers to the health of the heart and blood vessels. Cardiovascular disease is a group of diseases of the heart and blood vessels, including coronary heart disease, stroke, heart failure, heart arrhythmias, and heart valve problems."
  },
  {
    "id": 9,
    "name": "Chronic health",
    "icon": "fas fa-notes-medical",
    "description": "Chronic health conditions are long-lasting illnesses like diabetes or high blood pressure that need ongoing care and management to help people live as healthy as possible."
  },
  {
    "id": 10,
    "name": "Sports medicine",
    "icon": "fas fa-running",
    "description": "Sports medicine focuses on keeping athletes and active people healthy, treating sports-related injuries, and helping them perform their best."
  },
  {
    "id": 11,
    "name": "Eating disorders",
    "icon": "fas fa-utensils",
    "description": "Eating disorders are serious mental health conditions that affect how people think about and handle their food and body weight, often leading to unhealthy eating habits, and they may require therapy and medical help to recover."
  },
  {
    "id": 12,
    "name": "Immigration medical",
    "icon": "fas fa-passport",
    "description": "Immigration medical exams are health check-ups that some people have to do when moving to a new country, ensuring they don't have contagious diseases and are in good health for the safety of the host country."
  },
  {
    "id": 13,
    "name": "Pregnancy care",
    "icon": "fas fa-baby",
    "description": "Pregnancy care involves medical and emotional support for a woman when she's expecting a baby, making sure both the mother and baby stay healthy throughout the pregnancy."
  },
  {
    "id": 14,
    "name": "Nutrition",
    "icon": "fas fa-apple-alt",
    "description": "Nutrition is all about eating the right foods to keep your body healthy and functioning properly."
  },
  {
    "id": 15,
    "name": "Palliative care",
    "icon": "fas fa-hand-holding-heart",
    "description": "Palliative care is specialised medical care that focuses on making people with serious illnesses as comfortable as possible, managing pain and providing emotional support to improve their quality of life, especially when a cure may not be possible."
  },
  {
    "id": 16,
    "name": "Family Planning",
    "icon": "fas fa-users",
    "description": "Family planning means that people are able to voluntarily choose the number of children they have, and the spacing of pregnancies, through reliable methods of birth control."
  },
  {
    "id": 17,
    "name": "Travel medicine",
    "icon": "fas fa-plane",
    "description": "Travel medicine is a field of healthcare that helps people stay healthy when they're travelling to different places by giving advice, vaccinations, and information to prevent health problems that might come from visiting other regions or countries."
  },
  {
    "id": 18,
    "name": "Dermatology",
    "icon": "fas fa-hand-paper",
    "description": "Dermatology is the branch of medicine that deals with skin, hair, and nail health, focusing on diagnosing and treating various skin conditions and keeping the skin in good shape."
  },
  {
    "id": 19,
    "name": "Q Fever",
    "icon": "fas fa-bug",
    "description": ""
  }
];

export default medicalInterests;